import { AgeFilterType, GenderFilterType } from '@shared/types/filters'

import { UserModel } from './domain/user.model'
import { ageRangeObject } from './user.config'

export const transformBooleanGenderToString = (isMale: boolean | null) => {
  if (isMale === null) {
    return null
  }
  return isMale === true ? 'male' : 'female'
}

export function checkAgeInRanges(number: number, ranges: AgeFilterType[]) {
  for (let i = 0; i < ranges.length; i++) {
    const { from, to } = ageRangeObject[ranges[i]]

    if (to === null && number >= from) {
      return true
    }
    if (from === null && to !== null && number < to) {
      return true
    }
    if (number >= from && to !== null && number < to) {
      return true
    }
  }

  return false
}

export const getFilteredUsersForReport = (
  users: UserModel[],
  ageFilter: AgeFilterType[],
  genderFilter: GenderFilterType,
  phoneFilter: string
) => {
  const filtered = users.filter((user) => {
    const ageMatch = checkAgeInRanges(user.age, ageFilter)
    const genderMatch =
      genderFilter !== 'any' ? user.gender === genderFilter : true
    return ageMatch && genderMatch
  })
  return filtered.filter((user) =>
    user.phone.toLowerCase().includes(phoneFilter.toLowerCase())
  )
}
